import Entity from '@/common-utils/components/renders/entity/Entity';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
import { nsCustomization } from '@/app/i18n/namespaces';
import PropTypes from 'prop-types';
import actionsBeneficiaries from '../../../../beneficiaries/api/actionsBeneficiaries';
import { useEffect, useState } from 'react';
import BeneficiarySummary from '../../../../beneficiaries/components/BeneficiarySummary';
import customizationFields from '../../../fields/customizationFields';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import { Skeleton } from '@/common-utils/components/ui/skeleton';
import { useToast } from '@/common-utils/hooks/use-toast';
import './ModalAddBeneficiary.scss';


/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.contractAccessId
 * @param root0.beneficiaries
 * @param root0.setBeneficiaries
 * @returns {JSX} ModalAddBeneficiary
 */
function ModalAddBeneficiary({ isOpen, setIsOpen, contractAccessId, beneficiaries, setBeneficiaries }) {
    // Toast
    const { toast } = useToast();

    // State
    const [availableBeneficiaries, setAvailableBeneficiaries] = useState([]);
    const [selectedBeneficiaries, setSelectedBeneficiaries] = useState(beneficiaries);

    // API calls
    const { data, isLoading, error } = actionsBeneficiaries.getBeneficiaries({ contractAccessId: contractAccessId });

    // Hooks
    useEffect(() => {
        if (data) {
            setAvailableBeneficiaries(data.items);

        }
    }, [data]);

    // Functions
    const someBeneficiary = (beneficiary) => {
        return selectedBeneficiaries.some(benef => benef.uuid === beneficiary.uuid);
    };

    if (error) {
        setIsOpen(false);
        toast({
            description: <Entity entity='modal.add_beneficiaries.error' namespace={nsCustomization} />,
            variant: 'danger'
        });
    }

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className='max-w-xl'>
                <HeaderTitle title='modal.add_beneficiaries.title' namespace={nsCustomization} />
                <ModalBody id='modal-add-beneficiary-body'>
                    <Entity entity='modal.add_beneficiaries.text' namespace={nsCustomization} />
                    <div className='flex flex-col gap-2 overflow-y-auto max-h-[70vh] mt-4'>
                        {
                            isLoading &&
                            <Skeleton className='h-10 w-full' />
                        }
                        {
                            availableBeneficiaries?.map((beneficiary) => (
                                <div key={beneficiary[customizationFields.BENEFICIARIES.UUID.key]}
                                    onClick={() => {
                                        if (someBeneficiary(beneficiary)) {
                                            setSelectedBeneficiaries(selectedBeneficiaries.filter(benef => benef.uuid !== beneficiary.uuid));
                                        } else {
                                            setSelectedBeneficiaries([...selectedBeneficiaries, beneficiary]);
                                        }
                                    }}
                                    className={cn(
                                        someBeneficiary(beneficiary)
                                            ? 'selected'
                                            : 'border-gray-300 hover:bg-gray-100',
                                        'cursor-pointer p-2 rounded-md border'
                                    )}
                                >
                                    <BeneficiarySummary
                                        key={beneficiary[customizationFields.BENEFICIARIES.UUID.key]}
                                        color={beneficiary[customizationFields.BENEFICIARIES.COLOR.key]}
                                        name={beneficiary[customizationFields.BENEFICIARIES.NAME.key]}
                                        contracts={beneficiary[customizationFields.BENEFICIARIES.CONTRACTS.key]}
                                    />
                                </div>
                            ))
                        }
                    </div>
                </ModalBody>
                <FooterForm
                    onSubmit={() => {
                        setBeneficiaries(selectedBeneficiaries);
                        setIsOpen(false);
                    }}
                    isSubmitDisabled={isLoading}
                />
            </ModalContent>
        </Modal>
    );
}

ModalAddBeneficiary.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    contractAccessId: PropTypes.string.isRequired,
    beneficiaries: PropTypes.array.isRequired,
    setBeneficiaries: PropTypes.func.isRequired
};

export default ModalAddBeneficiary;